import BathSection from './BathSection';

export default BathSection;
